import styled from "styled-components"

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding-top: 1rem;
  width: 100%;
  & > div {
    min-width: 200px;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    text-transform: uppercase;
    & > span.field {
      font-weight: bold;
    }
  }
`
